/* Visual feedback only. Checkout remains the authority for discounts. */
(() => {
  let previousUnlocked = null;
  let frame = 0;
  function inspectJourney() {
    frame = 0;
    const journeys = [...document.querySelectorAll('[data-cart-journey]')];
    if (!journeys.length) { previousUnlocked = 0; return; }
    const unlocked = Number(journeys[0].dataset.unlocked);
    if (previousUnlocked !== null && unlocked > previousUnlocked) {
      journeys.forEach(journey => {
        journey.classList.add('is-celebrating');
        window.setTimeout(() => journey.classList.remove('is-celebrating'), 950);
      });
    }
    previousUnlocked = unlocked;
  }
  function scheduleInspection() {
    if (!frame) frame = window.requestAnimationFrame(inspectJourney);
  }
  function start() {
    inspectJourney();
    // Cart sections are replaced after quantity changes and removals.
    const drawer = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');
    const observer = new MutationObserver(scheduleInspection);
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
    if (cartFooter) observer.observe(cartFooter, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
